import type { FC } from 'react';
import { routes } from '~/utils/routes';
import {
  Actionsheet,
  actionsheetOptionStyle,
  actionsheetOptionLinkStyle,
} from '@app/_components/actionsheet';
import { Link } from '@app/_components/link';
import { css } from '@styled-system/css';
import { VStack, HStack } from '@styled-system/jsx';
import moreIcon from './assets/more-icon.svg';

interface Props {
  storyId: string;
  seriesId: string;
  isOpen: boolean;
  open: () => void;
  onClickInappropiateContent: () => void;
  close: () => void;
}

export const ReportActionsheet: FC<Props> = ({
  storyId,
  seriesId,
  isOpen,
  open,
  onClickInappropiateContent,
  close,
}) => {
  return (
    <>
      <HStack
        onClick={open}
        margin="0 0 0 auto"
        cursor="pointer"
        data-testid="report-button"
      >
        <img
          src={moreIcon}
          alt="報告する"
          className={css({ cursor: 'pointer' })}
          loading="lazy"
        />
      </HStack>

      <Actionsheet open={isOpen || false} onClose={close}>
        <VStack position="relative" zIndex="share_popover">
          <div className={css({ minHeight: '150px', minWidth: '100%' })}>
            <ul
              className={css({
                marginTop: '10px',
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: 'size_14',
                fontWeight: '700',
              })}
            >
              <li className={actionsheetOptionStyle}>
                <a
                  className={actionsheetOptionLinkStyle}
                  onClick={onClickInappropiateContent}
                  rel="nofollow"
                >
                  不適切なコンテンツ
                </a>
              </li>
              <li className={actionsheetOptionStyle}>
                <Link
                  href={routes.story.copyrightReport.image.url(storyId)}
                  className={actionsheetOptionLinkStyle}
                  rel="nofollow"
                >
                  アイコン・挿絵の転載
                </Link>
              </li>
              <li className={actionsheetOptionStyle}>
                <Link
                  href={routes.series.copyrightReport.image.url(seriesId)}
                  className={actionsheetOptionLinkStyle}
                  rel="nofollow"
                >
                  作品カバー画像の転載
                </Link>
              </li>
              <li className={actionsheetOptionStyle}>
                <Link
                  href={routes.story.copyrightReport.text.url(storyId)}
                  className={actionsheetOptionLinkStyle}
                  rel="nofollow"
                >
                  文章の転載（権利者の方のみ）
                </Link>
              </li>
            </ul>
          </div>
        </VStack>
      </Actionsheet>
    </>
  );
};
